import { useTranslations } from "next-intl";
import { useCurrentUser } from "@hooks/use-current-user";
import { userState } from "@utils/constants/user";
import subscriptionStatus from "@utils/subscriptionStatus";
import { subscriptionStatuses } from "@utils/constants/subscriptionStatuses";
import Link from "@components/core/Link";
import ProfileLayoutLink from "./ProfileLayoutLink";

function ProfileLayout({ loading = false, children }) {
  const t = useTranslations("common");

  const user = useCurrentUser();
  const userSubscriptionStatus = subscriptionStatus(user?.subscription);

  return (
    <div className="container profile-layout">
      <div className="row">
        <div className="col-0 col-lg-4 links-panel p-0">
          <ProfileLayoutLink href="/profile">{t("navbar.profile.my_profile")}</ProfileLayoutLink>
          <ProfileLayoutLink href="/closets">{t("navbar.profile.my_closets")}</ProfileLayoutLink>
          {(user?.state === userState.subscriber ||
            userSubscriptionStatus === subscriptionStatuses.paused) && (
            <ProfileLayoutLink href="/profile/manage-subscription">
              {t("navbar.profile.my_subscription")}
            </ProfileLayoutLink>
          )}
          <ProfileLayoutLink href="/profile/manage-sizes">
            {t("navbar.profile.my_sizes")}
          </ProfileLayoutLink>
          <ProfileLayoutLink href="/profile/referral">
            {t("navbar.profile.refer_friend")}
          </ProfileLayoutLink>
          <ProfileLayoutLink href="/profile/referral-details">
            {t("navbar.profile.my_referrals")}
          </ProfileLayoutLink>
          <ProfileLayoutLink href="/profile/manage-info">
            {t("navbar.profile.my_informations")}
          </ProfileLayoutLink>
          <ProfileLayoutLink href="/profile/addresses">
            {t("navbar.profile.my_addresses")}
          </ProfileLayoutLink>
          <ProfileLayoutLink href="/profile/rewards">
            {t("navbar.profile.my_rewards")}
          </ProfileLayoutLink>
          <ProfileLayoutLink href="/profile/invoices">
            {t("navbar.profile.my_payments")}
          </ProfileLayoutLink>
          <div className="p-3">
            <Link
              href="/sign-out"
              className="link-primary w-100 text-center"
              noUnderline
            >
              {t("navbar.profile.logout")}
            </Link>
          </div>
        </div>
        <div className="col-12 col-lg-8 py-0 px-3 px-lg-5">{!loading && user && children}</div>
      </div>
    </div>
  );
}

export default ProfileLayout;
